<template>
  <Modal
    :width="'100vw'"
    :visible="props.visible"
    @update:visible="(v) => (v ? emits('update:visible', v) : close())"
    :footer="null"
    :title="null"
    :maskClosable="false"
    :wrapClassName="$style.Modal"
  >
    <div :class="$style.Expire" v-if="activeEndTime && activeSku?.type === SKU_TYPE.ACTIVITY">
      {{ `${activeEndTime?.h}:${activeEndTime?.m}:${activeEndTime?.s}` }} 后失效
    </div>

    <div :class="$style.Info">
      <div>购买灵豆套餐</div>
      <!-- <div style="font-weight: 400">常见问题</div> -->
      <a
        style="font-weight: 400; color: #fff"
        target="_blank"
        href="https://www.lingvisions.com/cases/20"
      >
        常见问题
      </a>
    </div>
    <!-- <Header
      :class="$style.Header"
      style="padding: 16px"
      :avatarUrl="orgInfo.logo"
      :title="orgInfo.fullName"
      :lingdouNum="lingdouInfo?.total"
      :isPersonal="isPersonal"
      :expireTime="lingdouInfo?.memberShip?.expireTime"
      :isVip="isVip"
      :avatarSize="48"
      v-if="orgInfo"
    /> -->

    <!-- <div
      :class="$style.Padding"
      style="display: flex; flex-direction: column; margin-top: 16px"
      v-else
    >
      <SkeletonButton :class="[$style.SkeletonButton]" style="width: 100px; height: 72px" />
      <SkeletonButton
        :class="[$style.SkeletonButton]"
        style="width: 100px; height: 38px; margin-top: 16px"
      />
    </div> -->

    <!-- <div :class="$style.SkuError" v-if="skuError"
      ><Button type="primary" @click="init">出错啦，点击重新加载</Button></div
    >
    <div :class="[$style.Skus, $style.Padding]" v-else-if="skuLoading">
      <SkeletonButton v-for="item in 2" :key="item" :class="$style.SkeletonButton" />
    </div> -->

    <!-- <template v-else>
      <div :class="[$style.Skus]">
        <Sku
          v-for="(item, index) in skusList"
          :recommendTitle="
            index === 0
              ? isPersonal
                ? item.type === SKU_TYPE.PURCHASE
                  ? ''
                  : '最划算'
                : '团队优选'
              : ''
          "
          :key="item.id"
          :description="item.description"
          :des="item.des"
          :amount="item.amount"
          :originPrice="item.originPrice"
          :price="item.price"
          :expiresIn="item.expiresIn"
          :active="item.skuId === activeSkuId"
          :type="item.type"
          :first="item.first"
          @click="handleActiveSku(item.skuId)"
        />
      </div>
    </template> -->

    <!-- <ChannelSelect :class="$style.Padding" style="margin-top: 16px" v-model:value="channel" /> -->

    <div :class="$style.Padding" style="margin-top: 16px">
      <Introduction
        style="width: 100%; height: 436px; border-radius: 16px; position: relative"
        :isPersonal="isPersonal"
        :loading="skuLoading"
        :amount="activeSku?.amount"
        :expiresIn="activeSku?.expiresIn"
        :seatNum="activeSku?.seat"
        :price="activeSku?.displayPrice"
        :crawlLimit="activeSku?.crawlLimit"
        :nightMode="activeSku?.nightMode"
        :insertTexts="
          activeSku?.type === SKU_TYPE.ACTIVITY && activeSku?.description
            ? [
                {
                  title: activeSku?.description,
                },
              ]
            : []
        "
        :listTitle="activeSku?.type === SKU_TYPE.ACTIVITY ? `${activityDetail?.name}活动专属` : ''"
      >
        <template #header>
          <div :class="$style.IntroductionTitle">
            <template v-if="+activeSku?.amount! < 10000">{{ activeSku?.amount }}灵豆</template>
            <template v-else>{{ +activeSku?.amount! / 10000 }}万灵豆</template>
          </div>
        </template>
        <template #footer v-if="!skuLoading">
          <div :class="$style.IntroductionFooter">
            <MobileSku
              :skus="skusList"
              :active="activeSkuId"
              @update:active="(skuId) => handleActiveSku(skuId)"
            />
          </div>
        </template>
      </Introduction>
    </div>

    <MobilePay
      style="margin-top: 16px"
      :key="refreshPayComponent"
      :skuId="activeSkuId"
      :channel="channel"
      :wxConfig="props.wxConfig"
      :zfbConfig="props.zfbConfig"
      :originPrice="activeSku?.originPrice"
      @success="handlePaySuccess"
    />
    <div :class="[$style.Protocol]">
      <span style="color: #ffffffd9">
        支付即视为您已同意
        <Protocol />
      </span>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
  import { ref, watch, computed, onUnmounted } from 'vue';
  import { Modal, SkeletonButton, Button, Checkbox } from 'ant-design-vue';

  import Protocol from '../components/protocol.vue';
  import MobilePay from '../components/mobile-pay.vue';
  import Introduction from '../components/introduction/index.vue';

  import { GetSkusRes } from '../apis/entities';
  import { usePayment } from './hooks/usePayment';
  import { PAY_CHANNEL, SKU_TYPE } from '../constants';
  import { copyTextToClipboard } from '../utils/copy';
  import MobileSku from '../components/mobile-sku.vue';

  const props = defineProps({
    visible: {
      type: Boolean,
      default: false,
    },

    getUserInfo: {
      type: Function,
      default: null,
    },

    getOrgInfo: {
      type: Function,
      default: null,
    },

    getLingdouInfo: {
      type: Function,
      default: null,
    },

    onPaySuccess: {
      type: Function,
      default: null,
    },

    onPayCancel: {
      type: Function,
      default: null,
    },

    defaultActiveSkuId: {
      type: Number,
      default: null,
    },

    wxConfig: {
      type: Object,
      required: true,
    },

    zfbConfig: {
      type: Object,
      required: true,
    },

    activityCode: {
      type: String,
      default: null,
    },
  });

  const emits = defineEmits(['update:visible']);

  const {
    skus,
    skuLoading,
    skuError,
    orgInfo,
    activeSkuId,
    activeSku,
    init,
    handleActiveSku,
    isPersonal,
    activityDetail,
  } = usePayment({
    getUserInfo: props.getUserInfo,
    getOrgInfo: props.getOrgInfo,
    getLingdouInfo: props.getLingdouInfo,
    activityCode: props.activityCode,
  });

  const channel = ref(PAY_CHANNEL.WECHAT);

  const skusList = computed(() => {
    return skus.value;
  });

  const activeEndTime = ref();

  function getCountdown(endTimeStr) {
    const endTime = new Date(endTimeStr).getTime();
    const now = Date.now();
    let diff = Math.max(0, Math.floor((endTime - now) / 1000)); // 剩余秒数

    const h = String(Math.floor(diff / 3600)).padStart(2, '0');
    diff %= 3600;
    const m = String(Math.floor(diff / 60)).padStart(2, '0');
    const s = String(diff % 60).padStart(2, '0');

    return { h, m, s };
  }

  let timer;
  watch(
    () => props.visible,
    async (v) => {
      if (v) {
        await init();

        if (props.activityCode) {
          timer = setInterval(() => {
            activeEndTime.value = getCountdown(activityDetail.value?.endTime);
          }, 1000);
        }

        // 如果有默认选中的sku，则切换对应tab下
        if (props.defaultActiveSkuId) {
          const sku = skus.value.find((v) => v.skuId === props.defaultActiveSkuId);
          if (sku) {
            handleActiveSku(props.defaultActiveSkuId);
          }
        } else {
          // 有活动选择第一个
          if (props.activityCode) {
            handleActiveSku(skus.value[0].skuId);
          } else {
            handleActiveSku(skus.value[1].skuId);
          }
        }
      }
    },
    {
      immediate: true,
    }
  );

  onUnmounted(() => {
    clearInterval(timer);
  });

  const refreshPayComponent = ref(0);
  watch(
    () => activeSkuId.value,
    () => {
      refreshPayComponent.value++;
    }
  );

  // 支付成功
  function handlePaySuccess(result) {
    close();
    props?.onPaySuccess(result);
  }

  function close() {
    props?.onPayCancel();
    emits('update:visible', false);
  }

  const isCopy = ref(false);
  function handleCopy() {
    copyTextToClipboard(location.href);
    isCopy.value = true;
  }
</script>

<style lang="less" module>
  .Modal {
    padding: 0;

    :global {
      .ant-modal {
        position: fixed;
        max-width: unset;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: 0;
        padding: 0 !important;
      }

      .ant-modal-content {
        height: 100%;
        box-shadow: unset !important;
        background-color: rgba(20, 20, 20, 1);
      }

      .ant-modal-body {
        height: 100%;
        overflow: auto;
        padding: 0 0 100px;
      }
    }
  }

  .Expire {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 150px;
    background: rgba(31, 31, 31, 1);
    font-family: PingFang SC;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    line-height: 22px;
    color: rgba(255, 191, 0, 1);
    border-radius: 6px;
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
  }

  .Padding {
    margin: 0 16px;
  }

  .Header {
    background: url('https://static.lingvisions.com/public/1f57e0fba7d1455295a2009e2a827b11.png')
      center / cover no-repeat;
  }

  .SkeletonButton {
    width: 165px !important;
    height: 120px;

    > span {
      width: 100% !important;
      height: 100% !important;
    }
  }

  .Skus {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(2, 180px);
    gap: 10px 16px;
    margin-top: 16px;
    max-height: 260px;
    overflow: auto;
  }

  .PayBlock {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(40, 40, 40, 1);
    padding: 0 16px;
    border-radius: 6px;
  }

  .Protocol {
    margin-top: 8px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      display: flex;
      align-items: center;
    }
  }

  .SkuLoading {
    display: flex;
    align-items: center;
  }

  .SkuError {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 190px;
  }

  .Footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgb(31, 31, 31);
  }

  .Question {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;

    > a {
      color: rgba(255, 255, 255, 0.85) !important;
    }
  }

  .Copy {
    width: 176px;
    height: 40px !important;
    margin-top: 8px;
  }

  .IntroductionTitle {
    font-family: PingFang SC;
    font-weight: 600;
    font-style: Semibold;
    font-size: 32px;
    leading-trim: NONE;
    line-height: 32px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 32px;
  }

  .IntroductionFooter {
    position: absolute;
    bottom: 24px;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: rgba(255, 255, 255, 1);
    padding: 0 16px;
    margin-top: 62px;
  }
  @media (max-width: 500px) {
    .Skus {
      grid-template-columns: repeat(2, 165px);
    }
  }
</style>
